/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useCallback } from "react";
import { ISchemaConstBooleanModel, TGenericModelNode } from "@adapptio/lib-blueprint";
import { FieldSwitch } from "@adapptio/lib-editor-ui";
import { IInspectorControls, TInspectorControlComponent } from "../InspectorTypes";
import { useBlueprintModel } from "../../../hooks/useBlueprintModel";
import { InvalidModelNode } from "../InvalidModelNode";
import { useEditorInspectorContext } from "../../../contexts/EditorInspectorContext";

export const ControlConstBoolean_Control: TInspectorControlComponent<ISchemaConstBooleanModel> = ({
	model: _model
}) => {
	const editorInspectorCtx = useEditorInspectorContext();
	const { model } = useBlueprintModel(_model, "constBoolean");

	const handleChange = useCallback(
		(value: boolean) => {
			if (!model) {
				return;
			}

			model.schema.setValue(model, value, true);
		},
		[ model ]
	);

	if (!model) {
		return <InvalidModelNode model={_model} />;
	}

	return (
		<FieldSwitch value={model.value} onChange={handleChange} readOnly={editorInspectorCtx?.readOnly} />
	);
};

export const ControlConstBoolean = (model: TGenericModelNode): IInspectorControls => ({
	primary: {
		component: ControlConstBoolean_Control,
		model: model
	}
});
